module.exports = __webpack_public_path__ + "static/turquia-026-e474deb6879d342e912256fd74d5e3bd.jpg";